export function createRestrictiveInjectionState<Arguments extends Array<any>, Return>(
	composable: (...args: Arguments) => Return,
	msg = "Failed to inject"
): readonly [useProvidingState: (...args: Arguments) => Return, useInjectedState: () => Return] {
	const [provider, injector] = createInjectionState(composable);

	return [
		provider,
		() => {
			const injected = injector();
			if (!injected) throw new Error(msg);

			return injected;
		},
	];
}
